import createLogger from "../../utils/log2";

const log = createLogger("socketStatus");

const socketStatus = {
    namespaced: true,
    state: {
        socket_connected: false,
        connection_count: 0,
        current_socket: null,
        isUserLoggedViaSocket: false,
    },
    getters: {
        getSocket: (state) => () => {
            return state.current_socket;
        },
    },
    mutations: {
        SET_SOCKET_STATUS: (state, payload) => {
            const { socketConnected, userLoggedin } = payload;
            log.debug("SET_SOCKET_STATUS", payload);
            state.socket_connected = socketConnected;
            state.isUserLoggedViaSocket = userLoggedin;
            if (socketConnected) state.connection_count = state.connection_count + 1;
        },
        SET_SOCKET: (state, socket) => {
            log.debug("SET_SOCKET called", { socket });
            window.socket = socket;
            state.current_socket = socket;
        },
    },
    actions: {
        setSocketStatus({ commit }, payload) {
            const { socketConnected, userLoggedin } = payload;
            commit("SET_SOCKET_STATUS", { socketConnected, userLoggedin });
        },
        setSocket({ commit }, socket) {
            commit("SET_SOCKET", socket);
        },
    },
};

export default socketStatus;
